import styled from "styled-components";

export const NomenclatureWrapper = styled.div`
    position: relative;
`;